import 'primeicons/primeicons.css';
import 'primereact/resources/primereact.min.css';
import 'react-toastify/dist/ReactToastify.css';
import 'styles/theme.css';
import 'util/extensions';

import './App.css';

import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import StartupDialogsComponent from 'components/dialogs/StartupDialogsComponent';
import BillingStatusBanner from 'components/BillingStatusBanner';
import HideWhenNoLayout from 'components/HideWhenNoLayout';
import ApplicationLoadingSpinner from 'components/spinners/ApplicationLoadingSpinner';
import Footer from 'components/v2/Footer';
import Header from 'components/v2/header/Header';
import { ApplicationToastRoot } from 'components/v2/toast';
import { CompanyContext } from 'contexts/CompanyContextProvider';
import { useTheme } from 'hooks/useTheme';
import { useContext, useEffect, useState } from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import Routes from 'routes/Routes';
import { ThemeProvider } from 'styled-components';
import { ApplicationContentBody, ApplicationModalRoot } from 'styles/Styles.styled';
import queryClient from 'util/queryClient';

function App() {
  const [isLoadingState, setIsLoadingState] = useState<boolean>(true);
  // Note: useLocation outside of BrowserRouter doesn't refresh
  const location = useLocation();

  const PDF_BUILDER_PATHS = [
    '/epdcompilerpdfpreview',
    '/epdcompilerdocumentpreview',
    '/epdregistrationcertificatepdfpreview',
    '/dynamicformregistrationcertificatepdfpreview',
    '/fortnox/invoice',
    '/html-pdf-document',
  ];
  const isPdfBuilderUrl = location && PDF_BUILDER_PATHS.some((path) => location.pathname.toLowerCase().includes(path));

  const TRUSTED_DOMAINS = ['localhost', 'epd-portal-api', 'epd-portal-app', 'environdec.com'];
  const isFromOurDomain =
    process.env.REACT_APP_DEBUG || TRUSTED_DOMAINS.some((domain) => document.referrer.toLowerCase().includes(domain));

  const { refreshCompany, licensee } = useContext(CompanyContext);
  const { theme } = useTheme(licensee);

  useEffect(() => {
    if (isPdfBuilderUrl && isFromOurDomain) {
      return; 
    }
    refreshCompany();
    setIsLoadingState(false);
  }, []);
    
  if (isPdfBuilderUrl && isFromOurDomain) {

    return (
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <Routes />
        </ThemeProvider>
      </QueryClientProvider>
    );
  }

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        {isLoadingState ? (
          <ApplicationLoadingSpinner />
        ) : (
          <Router>
            <HideWhenNoLayout>
              <BillingStatusBanner />
              <Header />
            </HideWhenNoLayout>

            <ApplicationContentBody>
              <Routes />
            </ApplicationContentBody>

            <HideWhenNoLayout>
              <Footer />
            </HideWhenNoLayout>

            <ApplicationModalRoot id="modal" />
            <ApplicationToastRoot />
            <StartupDialogsComponent />
          </Router>
        )}
      </ThemeProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

export default App;
